{
    "coordinates": [
        38.8620170838191,
        -104.58994647270583
    ],
    "tooltip": "Corral Bluffs",
    "title": "Denver Formation (Corral Bluffs)",
    "country": "United States",
    "period": "Paleogene",
    "alt": "TODO"
}
